module.exports = __webpack_public_path__ + "img/slide14.3f874285.png";